import { Link, Outlet, } from "react-router-dom";
import { UserIcon, } from "@heroicons/react/24/outline";
import { Box, HStack, Icon, Stack, } from "@chakra-ui/react";

import { QRButton, } from "./QR";
import { LimitsBlock, } from "./Limits";
import { Logo, } from "../../shared/Logo";
import { RoutesMap, } from "../../../routes.tsx";
// import { CardIssuanceBlock, } from "./CardIssuance";
import { UpcomingPaymentBlock, } from "./UpcomingPayment";
import { FuturePaymentsEmptyBlock, OperationsBlock, } from "../../features/MainPage";
import { ContractTerminationNotice, } from "./ContractTerminationNotice";

interface IMainPageView {
  payments: {
    isSuccess: boolean;
    count: number;
  };
  isOperationsHistoryEnabled: boolean;
}

export function MainPageView({ payments, isOperationsHistoryEnabled, }: IMainPageView,) {
  if (payments.isSuccess && payments.count === 0) {
    return (
      <Stack spacing={4} mb={4} pt={2}>
        <Box>
          <HStack>
            <Logo />
            <Box flex="1" />
            <Box>
              <Link to={RoutesMap.profile}>
                <Box
                  w={12}
                  h={12}
                  borderRadius="full"
                  bg="gray.50"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon color="gray.500" as={UserIcon} boxSize={6} />
                </Box>
              </Link>
            </Box>
          </HStack>
        </Box>
        <ContractTerminationNotice />
        <UpcomingPaymentBlock />
        {/* <CardIssuanceBlock /> */}
        <LimitsBlock />
        <FuturePaymentsEmptyBlock />
        <QRButton />
        {/* <HowToBlock /> */}
        <Outlet />
      </Stack>
    );
  }

  return (
    <Stack id="mainPage" spacing={4} mb={4}>
      <Box py="25px">
        <HStack>
          <Logo />
          <Box flex="1" />
          <Box>
            <Link to={RoutesMap.profile}>
              <Box
                w={12}
                h={12}
                borderRadius="full"
                bg="gray.50"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon color="gray.500" as={UserIcon} boxSize={6} />
              </Box>
            </Link>
          </Box>
        </HStack>
      </Box>
      <ContractTerminationNotice />
      <UpcomingPaymentBlock />
      {/* <CardIssuanceBlock /> */}
      <Box mb="1" />
      {/* {isNextPaymentsEnabled && ( */}
      {/*  <FuturePaymentsBlock /> */}
      {/* )} */}
      {/* {isPaymentCardsEnabled && ( */}
      {/*  <PaymentCardsView /> */}
      {/* )} */}
      <LimitsBlock />
      <Box mb="1" />
      {isOperationsHistoryEnabled && (
        <OperationsBlock />
      )}
      <QRButton />
      <Outlet />
    </Stack>
  );
}
